export default {
  BT_HDP: "Kèo chấp",
  BT_OU: "Tài/Xỉu",
  BT_ML: "Dòng Tiền",
  BT_1X2: "1X2",
  BT_1X2HDP: "Cược 3 cách",
  BT_CS: "Tỷ số chính xác",
  BT_OE: "Lẻ/Chẵn",
  BT_DC: "Nhân đôi cơ hội",
  BT_HTFT: "Hiệp 1/ Cả trận",
  BT_FGLG: "Bàn thắng đầu/ cuối",//"Bàn thắng đầu/Bàn thắng cuối",
  BT_TG: "Tổng số bàn thắng",
  BT_OR: "Vô địch",
  BT_ORZ: "Vô địch",

  BT_ANB: "Khách không bàn thắng",
  BT_BS: "Cả hai đội/ Một đội/ Không đội nào có bàn thắng",
  BT_CL: "Không bị ghi bàn",
  BT_DNB: "Hoà không bàn thắng",
  BT_DNBH: "Hoà không bàn thắng hiệp 1",
  BT_HNB: "Chủ nhà không bàn thắng",
  BT_TWTN: "Lật ngược tình thế",

  BT_HDPF: "Kèo chấp cả trận",
  BT_OUF: "Tài/Xỉu cả trận",
  BT_MLF: "Dòng tiền cả trận",
  BT_1X2F: "1X2 cả trận",
  BT_1X2HDPF: "Cược 3 cách cả trận",
  BT_CSF: "Tỷ số chính xác cả trận",
  BT_OEF: "Lẻ/Chẵn cả trận",
  BT_DCF: "Nhân đôi cơ hội cả trận",
  BT_FGLGF: "Bàn thắng đầu/Bàn thắng cuối cả trận",
  BT_TGF: "Tổng số bàn thắng cả trận",

  BT_HDPH: "Kèo chấp hiệp 1",
  BT_OUH: "Tài/Xỉu hiệp 1",
  BT_MLH: "Dòng tiền hiệp 1",
  BT_1X2H: "1X2 hiệp 1",
  BT_1X2HDPH: "Cược 3 cách hiệp 1",
  BT_CSH: "Tỷ số chính xác hiệp 1",
  BT_OEH: "Lẻ/Chẵn hiệp 1",
  BT_DCH: "Nhân đôi cơ hội hiệp 1",
  BT_FGLGH: "Bàn thắng đầu/Bàn thắng cuối hiệp 1",
  BT_TGH: "Tổng số bàn thắng hiệp 1",
  BT_O: "Tài",
  BT_U: "Xỉu",
  BT_ODD: "Lẻ",
  BT_EVEN: "Chẵn",

  BT_HDPOU: "Kèo chấp và tài/xỉu",
  BT_PARLAY: "Xiên hỗn hợp",
  BT_FT: "Cả trận ",
  BT_1H: "Hiệp 1 ",
  BT_2H: "Hiệp 2 ",

  BT_FG: "Bàn thắng đầu",
  BT_LG: "Bàn thắng cuối",
  BT_HFG: "HF",//"Chủ nhà có bàn thắng đầu",
  BT_AFG: "AF",//"Khách có bàn thắng đầu",
  BT_HLG: "HL",//"Chủ nhà có bàn thắng cuối",
  BT_ALG: "AL",//"Khách có bàn thắng cuối",
  BT_NG: "NG",
  BT_HY: "Chủ nhà có",
  BT_HN: "chủ nhà không",
  BT_AY: "Khách có",
  BT_AN: "Khách không",
  BT_H: "Chủ nhà",
  BT_A: "Khách",
  BT_D: "Hoà",
  BT_HD_DC: "HD",//"Hiệp 1 chủ nhà thắng/Cả trận hoà",
  BT_HA_DC: "HA",//"Hiệp 1 chủ nhà thắng/Cả trận khách thắng",
  BT_DA_DC: "DA",//"Hiệp 1 hoà/Cả trận khách thắng",
  BT_HH: "HH",//"Hiệp 1 chủ nhà thắng/Cả trận chủ nhà thắng",
  BT_HD: "HD",//"Hiệp 1 chủ nhà thắng/Cả trận hoà",
  BT_HA: "HA",//"Hiệp 1 chủ nhà thắng/Cả trận khách thắng",
  BT_DH: "DH",//"Hiệp 1 hoà/Cả trận chủ nhà thắng",
  BT_DD: "DD",//"Hiệp 1 hoà/Cả trận hoà",
  BT_DA: "DA",//"Hiệp 1 hoà/Cả trận khách thắng",
  BT_AH: "AH",//"Hiệp 1 khách thắng/Cả trận chủ nhà thắng",
  BT_AD: "AD",//"Hiệp 1 khách thắng/Cả trận hoà",
  BT_AA: "AA",//"Hiệp 1 khách thắng/Cả trận khách thắng",

  BT_Y: "Có",
  BT_N: "Không",

  BT_LIVE: "Trực tiếp",
  BT_HT: "Nửa giờ",
  BT_DELAYED: "Trì hoãn",
  BT_PEN: "Luân lưu",

  BT_FT1: "Cả trận chủ nhà thắng",
  BT_FT2: "Cả trận khách thắng",
  BT_FTX: "Cả trận hoà",
  BT_HT1: "Hiệp 1 chủ nhà thắng",
  BT_HT2: "Hiệp 1 khách thắng",
  BT_HTX: "Hiệp 1 hoà",

  BT_BOTH: "Cả hai đội",
  BT_ONE: "Một đội",

  BS_HDP: "Kèo chấp cả trận",
  BS_HDPH: "Kèo chấp hiệp 1",
  BS_OU: "Tài/Xỉu cả trận",
  BS_OUH: "Tài/Xỉu hiệp 1",
  BS_OE: "Lẻ/Chẵn cả trận",
  BS_OEH: "Lẻ/Chẵn hiệp 1",
  BS_1X2: "1X2 cả trận",
  BS_1X2H: "1X2 hiệp 1",
  BS_ML: "Dòng tiền cả trận",
  BS_MLH: "Dòng tiền hiệp 1",
  BS_1X2HDP: "Cược 3 cách cả trận",
  BS_1X2HDPH: "Cược 3 cách hiệp 1",
  BS_CS: "Tỷ số chính xác cả trận",
  BS_CSH: "Tỷ số chính xác hiệp 1",
  BS_DC: "Nhân đôi cơ hội cả trận",
  BS_DCH: "Nhân đôi cơ hội hiệp 1",
  BS_FGLG: "Bàn thắng đầu/cuối cả trận",
  BS_FGLGH: "Bàn thắng đầu/cuối hiệp 1",
  BS_TG: "Tổng số bàn thắng cả trận",
  BS_TGH: "Tổng số bàn thắng hiệp 1",
  BS_ANB: "Khách không bàn thắng",
  BS_HTFT: "Hiệp 1/ Cả trận",
  BS_BS: "Cả hai đội/ Một đội/ Không đội nào có bàn thắng",
  BS_CL: "Không bị ghi bàn",
  BS_DNB: "Hoà không bàn thắng",
  BS_DNBH: "Hoà không bàn thắng hiệp 1",
  BS_HNB: "Chủ nhà không bàn thắng",
  BS_TWTN: "Lật ngược tình thế",
  BS_OR: "Vô địch",
  BS_ORZ: "Vô địch",

  LOT_BS: "B/S",
  LOT_BIG: "B",
  LOT_SMALL: "S",
  LOT_OE: "O/E",
  LOT_ODD: "O",
  LOT_EVEN: "E",
  LOT_OU: "O/U",
  LOT_OVER: "O",
  LOT_UNDER: "U",
  LOT_FT: "Cả trận",
  LOT_HT: "Nửa giờ",

  BT_ALLBT: "Tất Cả Loại Cược",

  D_1: "Số Đơn",
  D_2: "Số & Đảo Ngược",
  D_3: "Hộp",
  D_4: "iBox",
  D_5: "Hộp 3 Chữ Số Cuối",
  D_6: "Hộp 2 Chữ Số Cuối",

  D_BIG: "LỚN",
  D_SMALL: "NHỎ",
  D_AA: "AA",
  D_SA: "3A",
  D_SB: "B",
  D_SC: "C",
  D_SD: "D",
  D_SE: "E",
  D_ABC: "3C",

  LOT_1: "H",
  LOT_0: "A",

  BT_KO: "K.O. Bởi",

  ODD_Home: "H",
  ODD_Away: "A",
  ODD_Draw: "Hòa",
  ODD_Over: "O",
  ODD_Under: "U",
  ODD_Odd: "O",
  ODD_Even: "E",

  GH_1X2: "CHIẾN THẮNG",
  GH_1X20: "CHIẾN THẮNG",
  GH_1X2HDP: "ĐẶT/SHOW",
  GH_1X2HDP2: "ĐẶT",
  GH_1X2HDP4: "SHOW",
  GH_OVER: "TRÊN (4,5,6)",
  GH_UNDER: "DƯỚI (1,2,3)",
  GH_ODD: "LẺ (1,3,5)",
  GH_EVEN: "CHẴN (2,4,6)",
  GH_OU1: "TRÊN (4,5,6)",
  GH_OU2: "DƯỚI (1,2,3)",
  GH_OE1: "LẺ (1,3,5)",
  GH_OE2: "CHẴN (2,4,6)",

  GX_1X2: "CHIẾN THẮNG",
  GX_1X20: "CHIẾN THẮNG",
  GX_1X2HDP: "ĐẶT/SHOW",
  GX_1X2HDP2: "ĐẶT",
  GX_1X2HDP4: "SHOW",
  GX_OVER: "TRÊN (7-12)",
  GX_UNDER: "DƯỚI (1-6)",
  GX_ODD: "LẺ (1,3,5,7,9,11)",
  GX_EVEN: "CHẴN (2,4,6,8,10,12)",
  GX_OU1: "TRÊN (7-12)",
  GX_OU2: "DƯỚI (1-6)",
  GX_OE1: "LẺ (1,3,5,7,9,11)",
  GX_OE2: "CHẴN (2,4,6,8,10,12)",

  GC_OU: "O/U",
  GC_OE: "O/E",
  GC_OVER: "TRÊN (3,4,5)",
  GC_UNDER: "DƯỚI (0,1,2)",
  GC_ODD: "LẺ (1,3,5)",
  GC_EVEN: "CHẴN (0,2,4)",
  GC_5_0: "5-0",
  GC_4_1: "4-1",
  GC_3_2: "3-2",
  GC_0_5: "0-5",
  GC_1_4: "1-4",
  GC_2_3: "2-3",
  GC_ML0: "QUẢ BÓNG 1",
  GC_1X20: "ĐỂ THẮNG",
  GC_ML: "QUẢ BÓNG 1",
  GC_1X2: "ĐỂ THẮNG",
  GC_OU1: "TRÊN (3,4,5)",
  GC_OU2: "DƯỚI (0,1,2)",
  GC_OE1: "LẺ (1,3,5)",
  GC_OE2: "CHẴN (0,2,4)",

  GR_RED: "ĐỎ (1)",
  GR_YELLOW: "VÀNG (2)",
  GR_BLUE: "XANH DƯƠNG (3)",
  GR_GREEN: "XANH LÁ (4)",
  GR_OVER: "TRÊN (3,4)",
  GR_UNDER: "DƯỚI (1,2)",
  GR_ODD: "LẺ (1,3)",
  GR_EVEN: "CHẴN (2,4)",
  GR_SINGLE: "ĐƠN",
  GR_PAIR: "ĐÔI",
  GR_TRIPS: "BA",
  GR_ADVANCED: "VƯỢT QUA",
  GR_ELIMINATED: "LOẠI",
  GR_HIT1: "ĐÚNG 1",
  GR_HIT2: "ĐÚNG 2",
  GR_PERFECT: "HOÀN HẢO",
  GR_MLHOME: "VƯỢT QUA",
  GR_MLAWAY: "LOẠI",
  GR_1X2FT1: "ĐƠN",
  GR_1X2FTX: "ĐÔI",
  GR_1X2FT2: "BA",
  GR_ML1: "VƯỢT QUA",
  GR_ML2: "LOẠI",
  GR_1X21: "ĐƠN",
  GR_1X22: "BA",
  GR_1X23: "ĐÔI",
  GR_OU1: "TRÊN (3,4)",
  GR_OU2: "DƯỚI (1,2)",
  GR_OE1: "LẺ (1,3)",
  GR_OE2: "CHẴN (2,4)",

  ROOM_A: "Mở",
  ROOM_0: "Đang Hoạt Động",
  ROOM_1: "Đóng",
  ROOM_2: "Hủy",
  ROOM_3: "Kết Thúc",
  ROOM_4: "Dừng Cược",
  ROOM_10: "Tất Cả",

  ROOM_T0: "Tất Cả",
  ROOM_T1: "Phòng Công Cộng",
  ROOM_T2: "Phòng Riêng",
  ROOM_T3: "Chơi Để Kiếm",

  joinRoom1: "Tham Gia Phòng Công Cộng",
  joinRoom2: "Tham Gia Phòng Riêng",
  joinRoom3: "Tham Gia Phòng Chơi",
  createRoom1: "Tạo Phòng Công Cộng",
  createRoom2: "Tạo Phòng Riêng",
  createRoom3: "Tạo Phòng Chơi",
  Champion: "Nhà Vô Địch",
  FirstRunnerUp: "Á Quân 1",
  SecondRunnerUp: "Á Quân 2",

  BT_OEHM: "Chẵn/Lẻ Nhà",
  BT_OEHMH: "HT. Chẵn/Lẻ Nhà",
  BT_OEAW: "Chẵn/Lẻ Khách",
  BT_OEAWH: "HT. Chẵn/Lẻ Khách",

  BS_OEHM: "FT. Chẵn/Lẻ Nhà",
  BS_OEHMH: "HT. Chẵn/Lẻ Nhà",
  BS_OEAW: "FT. Chẵn/Lẻ Khách",
  BS_OEAWH: "HT. Chẵn/Lẻ Khách",

  MB_OVER: "TRÊN (4,5,6)",
  MB_UNDER: "DƯỚI (1,2,3)",
  MB_ODD: "LẺ (1,3,5)",
  MB_EVEN: "CHẴN (2,4,6)",

  BS_1X2OU: "1X2 + O/U",
  BT_1X2OU: "1X2 + O/U",
  BT_1O: "1O",
  BT_1U: "1U",
  BT_2O: "2O",
  BT_2U: "2U",
  BT_XO: "XO",
  BT_XU: "XU",

  BS_DCOU: "Cơ Hội Gấp Đôi + O/U",
  BT_DCOU: "Cơ Hội Gấp Đôi + O/U",
  BT_HDO: "HDO",
  BT_HDU: "HDU",
  BT_HAO: "HAO",
  BT_HAU: "HAU",
  BT_DAO: "DAO",
  BT_DAU: "DAU",

  BS_OUOE: "O/U + O/E",
  BT_OUOE: "O/U + O/E",
  BK_OO: "OO",
  BK_OE: "OE",
  BK_UO: "UO",
  BK_UE: "UE",

  BS_HTFTOE: "HT/FT + O/E",
  BT_HTFTOE: "HT/FT + O/E",
  BK_EO: "EO",
  BK_EE: "EE",

  BS_WM: "Biên Độ Thắng",
  BT_WM: "Biên Độ Thắng",
  BK_H1: "Nhà 1",
  BK_H2: "Nhà 2",
  BK_H3Up: "Nhà 3+",
  BK_A1: "Khách 1",
  BK_A2: "Khách 2",
  BK_A3Up: "Khách 3+",
  BK_D: "Hòa (Không tính 0-0)",
  BK_NG: "Không Có Bàn Thắng",

  BS_ETG: "Tổng Số Bàn Chính Xác",
  BT_ETG: "Tổng Số Bàn Chính Xác",
  BS_EHTG: "Tổng Số Bàn Chính Xác Nhà",
  BT_EHTG: "Tổng Số Bàn Chính Xác Nhà",
  BS_EATG: "Tổng Số Bàn Chính Xác Khách",
  BT_EATG: "Tổng Số Bàn Chính Xác Khách",
  BS_ETGH: "HT. Tổng Số Bàn Chính Xác",
  BT_ETGH: "HT. Tổng Số Bàn Chính Xác",
  BS_EHTGH: "HT. Tổng Số Bàn Chính Xác Nhà",
  BT_EHTGH: "HT. Tổng Số Bàn Chính Xác Nhà",
  BS_EATGH: "HT. Tổng Số Bàn Chính Xác Khách",
  BT_EATGH: "HT. Tổng Số Bàn Chính Xác Khách",
  BT_0: "0",
  BT_1: "1",
  BT_2: "2",
  BT_3: "3",
  BT_4: "4",
  BT_5: "5",
  BT_6Up: "6+",
  BT_3Up: "3+",

  BT_CSHTFT: "Tỷ số HT/FT",
  BS_CSHTFT: "Tỷ số HT/FT",
  BT_ETGHTFT: "Tổng Bàn HT/FT",
  BS_ETGHTFT: "Tổng Bàn HT/FT",

  CF_CS_2_1: "2-1",
  CF_CS_2_0: "2-0",
  CF_CS_0_2: "0-2",
  CF_CS_1_2: "1-2",
  CF_R_1_W: "Đội thắng hiệp 1",
  CF_R_2_W: "Đội thắng hiệp 2",
  CF_R_3_W: "Đội thắng hiệp 3",
  CF_MLHOME: "Đội nhà thắng",
  CF_MLAWAY: "Đội khách thắng",
  CF_EVEN: "Thi đấu 2 hiệp",
  CF_ODD: "Thi đấu 3 hiệp",
  CF_ML1: "Đội nhà thắng",
  CF_ML2: "Đội khách thắng",
  CF_ML: "Thắng thua",
  CF_CS: "Tỷ số chính xác",
  CF_OE: "Chẵn/Lẻ",
  CF_0: "Hòa",
  CF_1: "Chủ nhà",
  CF_2: "Đội khách",
  CF_OE1: "Chẵn",
  CF_OE2: "Lẻ",
    
  EF8_R1_1STBOOM: "BOOM ĐẦU TIÊN VÒNG 1",
  EF8_R2_1STBOOM: "BOOM ĐẦU TIÊN VÒNG 2",
  EF8_R3_1STBOOM: "BOOM ĐẦU TIÊN VÒNG 3",
  EF8_0: "-",
  EF8_1: "Chủ nhà",
  EF8_2: "Đội khách",

};